<div class="coverage__card__wrapper">
  <div class="coverage__card__header">
    <div class="flex-col w-full">
      <div class="flex w-full gap-5 justify-between">
        <div>
          <h2>{{ coverage().title }}</h2>
        </div>
        @if (coverage().recommended) {
        <app-recommended-badge />
        }
      </div>
      <div>{{ coverage().description }}</div>
    </div>
  </div>
  <div class="coverage__card__items">
    <div class="flex flex-col items-start justify-start mb-5">
      <app-coverage-price [coverage]="coverage()" [currency]="coverage().currency"/>
    </div>
    <strong class="text-grey-900">Coberturas</strong>
    <div class="mt-2">
      @for (item of coverage().items; track item) {
      <app-coverage-item [item]="item" />
      }
    </div>
  </div>
  <div class="p-5">
    <activar-button
      text="Seleccionar"
      color="primary"
      expand="full"
      (click)="setCoverage(coverage())"
    />
  </div>
</div>
